import $ from "jquery"
import Combobox from "../../interface/combobox.class"
import ComboboxUI from "../../interface/combobox"
import Formatter from "../../model/formatter"
import Hook from "../../hook"

/** Return view */
class QuickEditHook extends Hook {
  /**
   * Setup variables
   * @param {Window} window - Window
   * @returns {Promise} Promise
   */
  async afterProcess(window) {
    if (window.output.Data.Type !== "quickeditform") {
      return
    }

    window.selectProductionAssistant = false
    if (window.input.Subject === "Sales.CUST_vw_ScanProduct") {
      window.selectProductionAssistant = true
      window.selectProductionAssistantColumn = "ProductionAssistant_Scanning"
    } else if (window.input.Subject === "Sales.CUST_vw_ModelProduct") {
      window.selectProductionAssistant = true
      window.selectProductionAssistantColumn = "ProductionAssistant_Model"
    } else if (window.input.Subject === "Sales.CUST_vw_EndControlProduct") {
      window.selectProductionAssistant = true
      window.selectProductionAssistantColumn = "ProductionAssistant_EndControl"
    }

    // eslint-disable-next-line require-atomic-updates
    window.saveQuickEdit = async () => {
      if (!window.customData.rows) {
        return
      }

      if (window.customData.rows.filter(r => r.selected).length === 0) {
        window.message(
          "warning",
          window.session.translations.AdminDesktop_AlertNoRowsSelected,
        )
        return
      }

      let productionAssistant = null
      let uniChanges = []

      if (window.selectProductionAssistant) {
        productionAssistant = $("[name=ProductionAssistant]").val()
      }

      // get all rows
      let $tableRows = $(window.element)
        .find(".table-row")
        .toArray()

      // get all changes
      let changes = window.customData.rows.map(r => {
        if (r.selected) {
          if (window.selectProductionAssistant) {
            r.old[window.selectProductionAssistantColumn] = productionAssistant
          }
          return r.old
        }

        return null
      })

      // construct data and criteria for each row
      $tableRows.forEach(function constructCriteria(tableRowEl, rowIndex) {
        let criteria = null
        let rowData = window.customData.rows[rowIndex]

        if (rowData && !rowData.groupedRow && changes[rowIndex]) {
          criteria = {}
          // construct criteria
          for (let columnIndex in window.customData.FullTable.Columns) {
            let column = window.customData.FullTable.Columns[columnIndex]

            if (column.IsPrimaryKey) {
              criteria[column.Name] = window.customData.FullTable.Rows[
                rowIndex
              ].filter(x => x.Column.Name === column.Name)[0].Value
            }
          }

          uniChanges.push({Criteria: criteria, Values: changes[rowIndex]})
        }
      })

      let opts = {
        changes: uniChanges,
        tableName: window.input.Subject,
      }

      await Hook.run("saveBulk", window, async () => {
        // save values
        let result = await window.session.request(
          "/Admin/WebServices/CoreWebServices.asmx/SaveBulk",
          opts,
        )

        await window.handleActionResponse(result)

        if (!result.ContainsAnyWarningsOrErrors) {
          // window.dispose(false)

          // Refresh the window instead of reload (comboboxes were keeping the old value, and when lines disappeard they got the wrong value)
          window.reset('skipconfirm', true, {
            quickEditAvoidRequestRows: true, 
            selectionObjectText: window.customData.SelectionObjectText,  
            selectionObjectValue: window.customData.SelectionObjectValue,  
          })
        }
      })
    }

    window.customData.canSelectValue = false

    window.customData.rows = []
    window.customData.combobox = {
      type: Combobox.new(null, {
        name: "Type",
      }),
      value: Combobox.new(null, {
        name: "Value",
        tableName: "",
        columnName: "",
        readOnly: true,
      }),
    }

    if (window.selectProductionAssistant) {
      window.customData.combobox.productionAssistant = Combobox.new(null, {
        name: "ProductionAssistant",
        tableName: "Sales.CUST_ProductionAssistant",
        columnName: "Description",
        readOnly: false,
      })
    }

    window.SetValueDropDown = async type => {
      let col = window.output.Table.Columns.filter(
        c => c.Name === "Value",
      ).pop()

      let fullTableName = "Customer.Customer"
      let columnName = "CustomerID"

      switch (type) {
        case "CustomerID":
          fullTableName = "Customer.Customer"
          columnName = "CustomerID"
          break
        case "DimensionObjectID":
          fullTableName = "Customer.DimensionObject"
          columnName = "DimensionObjectID"
          break
        case "OrderID":
          fullTableName = "Sales.Order"
          columnName = "OrderID"
          break
        case "CUST_InearsOrderID":
          fullTableName = "Sales.Order"
          columnName = "CUST_InearsOrderID"
          break
        case "Reference":
          fullTableName = "Sales.Order"
          columnName = "Reference"
          break
        case "TransactionTypeID":
          fullTableName = "Sales.TransactionType"
          columnName = "TransactionTypeID"
          break
        case "ProductLeft":
        case "ProductRight":
          fullTableName = "Sales.CUST_Product"
          columnName = "ProductID"
          break
        case "Condition":
          fullTableName = "Sales.CUST_Product"
          columnName = "Condition"
          break
        case "ProductionBatch":
        case "ProductionBatchFilter":
          fullTableName = "Sales.CUST_Product"
          columnName = "ProductionBatch"
          break
        case "ProductNumber":
        case "ProductNumberFilter":
          fullTableName = "Sales.CUST_Product"
          columnName = "ProductNumber"
          break
      }

      if (!col) {
        window.output.Table.Columns.push({
          Name: "Value",
        })
      }

      $.each(window.output.Table.Columns, function() {
        if (this.Name === "Value") {
          this.Dropdown = {
            TableName: fullTableName,
            ColumnName: columnName,
          }
        }
      })
    }

    window.SetValueDropDown("CustomerID")

    window.customData.isSearch = false
    window.options.noNewLines = true
    window.customData.columns = window.output.Table.Columns
    window.customData.FullTable = window.output.FullTable

    handleRows(window, window.output.Data.Rows)

    let criteriaTypes = []

    criteriaTypes.push({
      Value: "*",
      Text: window.session.translations.StatusAll,
    })

    for (let index in window.output.FullTable.Columns) {
      if (
        !window.output.FullTable.Columns[index].AllowEditOnTable &&
        window.output.FullTable.Columns[index].Dropdown
      ) {
        criteriaTypes.push({
          Value: window.output.FullTable.Columns[index].Name,
          Text: window.output.FullTable.Columns[index].Title,
        })
      }
    }

    window.customData.combobox.type.populate(criteriaTypes)

    window.customData.combobox.type.setInitialValues(
      window.customData.SelectText,
      window.customData.SelectValue,
    )

    window.customData.combobox.value.setInitialValues(
      window.customData.SelectionObjectText,
      window.customData.SelectionObjectValue,
    )

    // Window button events, filter out generic buttons. Keep table-specific buttons
    let buttons = window.output.Buttons.filter(x => x.FullTableName !== "*")
    window.output.Buttons = [
      {
        Event: "save-quick-edit",
        Title: window.session.translations.Save,
      },
      {
        Event: window.parent ? "reset:confirm" : "dispose:confirm",
        Title: window.session.translations.Cancel,
      },
      // {
      //     Event: "open-planner-modal",
      //     Title: window.session.translations.ButtonPlanner,
      // },
    ].concat(buttons)
  }

  /**
   * Rental view functionality
   * @param {Window} window - Window
   * @returns {Promise} Promise
   */
  async afterRender(window) {
    if (window.output.Data.Type != "quickeditform" || window.customInit) {
      return
    }

    window.customInit = true

    $(window.element).off()

    let opts = {request: window.input}
    if (opts.request.Criteria.length === 1) {
      for (let index in window.customData.combobox.type.items) {
        let item = window.customData.combobox.type.items[index]
        if (opts.request.Criteria[0][item.value]) {
          window.toggleLoading(true)

          let selectedTypeColumn = window.output.FullTable.Columns.filter(
            x => x.Name === item.value,
          )[0]

          if (!window.restoreWindowObject || !window.restoreWindowObject.selectionObjectValue || !window.restoreWindowObject.selectionObjectText)
          {
            let availableValuesForType = await window.session.combobox(
              selectedTypeColumn.Dropdown.TableName,
              selectedTypeColumn.Dropdown.ColumnName,
            )
            let selectedValue = availableValuesForType.filter(
              x => x.Value == opts.request.Criteria[0][item.value],
            )[0]

            if (selectedValue) {
              window.customData.SelectionObjectText = selectedValue.Text || ""
              window.customData.SelectionObjectValue = selectedValue.Value
            }  
          } else {
            window.customData.SelectionObjectText = window.restoreWindowObject.selectionObjectText
            window.customData.SelectionObjectValue = window.restoreWindowObject.selectionObjectValue
          }

          window.customData.SelectText = item.text
          window.customData.SelectValue = item.value
          
          let selectedColumn = window.output.FullTable.Columns.filter(
            x => x.Name === window.customData.SelectValue,
          )[0]
          window.customData.combobox.value = Combobox.new(null, {
            name: "Value",
            tableName: selectedColumn.Dropdown.TableName,
            columnName: selectedColumn.Dropdown.ColumnName,
            readOnly: false,
          })

          await requestRows(window, opts)
          break
        }
      }
    }

    $(window.element).on(
      "value-accept",
      "[name=Type]",
      async function typeSelected() {
        let val = $(this).val()

        if (!val) {
          return
        }

        let comboboxInput = $(this)
          .closest(".combobox")
          .find("input.combobox-input")

        window.customData.SelectText = comboboxInput.val()
        window.customData.SelectValue = val
        window.customData.combobox.type.setInitialValues(
          window.customData.SelectText,
          window.customData.SelectValue,
        )

        window.SetValueDropDown(val)

        if (window.selectProductionAssistant) {
          window.customData.combobox.productionAssistant = Combobox.new(null, {
            name: "ProductionAssistant",
            tableName: "Sales.CUST_ProductionAssistant",
            columnName: "Description",
            readOnly: false,
          })
        }

        let opts = {request: window.input}
        if (opts.request.Criteria.length === 0) {
          opts.request.Criteria = [{}]
        }

        // Clear criteria for all other (previous selected) items
        for (let itemIndex in window.customData.combobox.type.items) {
          let item = window.customData.combobox.type.items[itemIndex]
          if (item.value != val) {
            delete opts.request.Criteria[0][item.value]
          }
        }

        // No value found, select all (no criteria)
        if (val === "*") {
          for (let columnIndex in window.customData.FullTable.Columns) {
            let column = window.customData.FullTable.Columns[columnIndex]

            if (column.IsPrimaryKey) {
              opts.request.Criteria[0][column.Name] = []
            }
          }

          // Retrieve data
          await requestRows(window, opts)
          return
        }

        let selectedColumn = window.output.FullTable.Columns.filter(
          x => x.Name === val,
        )[0]
        window.customData.combobox.value = Combobox.new(null, {
          name: "Value",
          tableName: selectedColumn.Dropdown.TableName,
          columnName: selectedColumn.Dropdown.ColumnName,
          readOnly: false,
        })

        await window.render()
      },
    )

    $(window.element).on("change", "[name=Value]", async function valueSelected(
      e,
      arg,
    ) {
      let val =
        typeof arg === "string" ? arg || $(this).val() : $(this).val() || null
      let comboboxInput = $(this)
        .closest(".combobox")
        .find("input.combobox-input")

      window.customData.SelectionObjectText = comboboxInput.val()
      window.customData.SelectionObjectValue = val

      window.customData.combobox.value.setInitialValues(
        comboboxInput.val(),
        val,
      )

      if (!val) {
        return
      }

      // Retrieve data
      let opts = {request: window.input}
      if (opts.request.Criteria.length === 0) {
        opts.request.Criteria = [{}]
      }

      opts.request.Criteria[0][window.customData.SelectValue] =
        window.customData.SelectionObjectValue
      await requestRows(window, opts)
    })

    $(window.element).on("click", ".table-body .field", function cellClick() {
      if ($(this).is("[contenteditable]") || $(this).hasClass("checkbox")) {
        return
      }

      let $row = $(this).closest(".table-row")
      let index = $(window.element)
        .find(".table-body .table-row")
        .index($row)
      let rowData = window.customData.rows[index]

      if (!rowData) {
        return
      }

      let $el = $row.find(".selection-box input")

      if ($el.prop("checked") === false) {
        $el.prop("checked", !$el.prop("checked")).change()
      }
    })

    $(window.element).on(
      "change",
      ".table-body .table-cell.field .dropdown.combobox input",
      async function cellChange() {
        let $row = $(this).closest(".table-row")
        let index = $(window.element)
          .find(".table-body .table-row")
          .index($row)
        let colName
        if ($(this).attr("name")) {
          colName = $(this)
            .attr("name")
            .replace(/(\[|\])/g, String())
        }
        let rowData = window.customData.rows[index]
        let value = $(this).val()
        let text = $(this)
          .closest(".combobox")
          .find("input.combobox-input")
          .val()

        window.customData.rows[index].old[colName] = value

        if (rowData.groupedRow) {
          // Grouped row, loop through all next rows and set dropdown to the same value and text
          for (let rowIndex in window.customData.rows) {
            if (rowIndex > index) {
              if (window.customData.rows[rowIndex].groupedRow) {
                break // Next grouped row, stop for-loop
              }

              let $el = $(
                "[name*='" + colName + "']",
                $(window.element).find(".table-body .table-row")[rowIndex],
              ).closest(".combobox")
              let cb = ComboboxUI.getClass($el)

              if (!cb.specification.freeType && !cb.optionExist(text, value)) {
                window.toggleLoading(true)
                await ComboboxUI.fetch(cb)
              }

              ComboboxUI.select(cb, text, value)
              ComboboxUI.close(cb)
              window.customData.rows[rowIndex].old[colName] = value
            }
          }
        }

        window.toggleLoading(false)
      },
    )

    $(window.element).on(
      "click",
      ".table-body .table-cell.field.checkbox input",
      function checkboxClick() {
        let $row = $(this).closest(".table-row")
        let index = $(window.element)
          .find(".table-body .table-row")
          .index($row)
        let colName = $(this)
          .attr("name")
          .replace(/(\[|\])/g, String())
        let rowData = window.customData.rows[index]
        let checked = $(this).is(":checked")

        window.customData.rows[index].old[colName] = checked
        $row
          .find(".selection-box input")
          .prop("checked", true)
          .change()

        if (rowData.groupedRow) {
          // Grouped row, loop through all next rows and check or uncheck checkbox
          for (let rowIndex in window.customData.rows) {
            if (rowIndex > index) {
              if (window.customData.rows[rowIndex].groupedRow) {
                break // Next grouped row, stop for-loop
              }

              window.customData.rows[rowIndex].old[colName] = checked
              $(
                "[name*='" + colName + "']",
                $($(window.element).find(".table-body .table-row")[rowIndex]),
              ).prop("checked", checked)
            }
          }
        }
      },
    )

    $(window.element).on(
      "blur paste change value-change",
      ".table-body [contenteditable]",
      function textareaChange() {
        let $row = $(this).closest(".table-row")
        let index = $(window.element)
          .find(".table-body .table-row")
          .index($row)
        let colName = $(this)
          .attr("name")
          .replace(/(\[|\])/g, String())
        let col = window.customData.columns
          .filter(c => c.Name === colName)
          .pop()
        let rowData = window.customData.rows[index]

        window.customData.rows[index].old[colName] = Formatter.serializeValue(
          col,
          $(this).text(),
        )
        $row
          .find(".selection-box input")
          .prop("checked", true)
          .change()

        if (rowData.groupedRow) {
          // Grouped row, loop through all next rows and set content editables to the same text
          for (let rowIndex in window.customData.rows) {
            if (rowIndex > index) {
              if (window.customData.rows[rowIndex].groupedRow) {
                break // Next grouped row, stop for-loop
              }

              window.customData.rows[rowIndex].old[
                colName
              ] = Formatter.serializeValue(col, $(this).text())
              $(
                "[name*='" + colName + "']",
                $($(window.element).find(".table-body .table-row")[rowIndex]),
              ).text($(this).text())
            }
          }
        }
      },
    )

    $(window.element).on(
      "change",
      ".table-row .selection-box input",
      function inputChange() {
        let $tr = $(this).closest(".table-row")

        let index = $(window.element)
          .find(".table-body .table-row")
          .index($tr)
        let rowData = window.customData.rows[index]

        if (!rowData) {
          return
        }

        let check = $(this).prop("checked")

        // Keep check at true if the checkbox itself was not clicked
        //if (!check && event.target !== this) {
        //  $(this).prop("checked", true)
        //  check = true
        //}

        if (index > -1 && window.customData.rows.length > index) {
          window.customData.rows[index].selected = check

          if (rowData.groupedRow) {
            // Grouped row, loop through all next rows and set selected to the same value
            for (let rowIndex in window.customData.rows) {
              if (rowIndex > index) {
                if (window.customData.rows[rowIndex].groupedRow) {
                  break // Next grouped row, stop for-loop
                }

                window.customData.rows[rowIndex].selected = check
                window.selectRow(rowIndex, check)

                // Check input from this (detail) tablerow
                $(
                  $(window.element).find(
                    ".table-body .table-row .selection-box input",
                  )[rowIndex],
                ).prop("checked", check)
              }
            }
          }
        }
      },
    )
  }
}

function formatRow(window, r, serializeValues = false) {
  let row = {}

  for (let columnName in r) {
    let column = window.output.Data.Columns[columnName]

    if (column) {
      row[columnName] = serializeValues
        ? Formatter.serializeValue(column, r[columnName])
        : Formatter.parseValue(column, r[columnName])
    }
  }

  return row
}

async function requestRows(window, opts) {
  window.toggleLoading(true)

  let newdata
  if (!window.restoreWindowObject || !window.restoreWindowObject.quickEditAvoidRequestRows) {
    try {
      newdata = await window.session.request(
        "/Admin/WebServices/CoreWebServices.asmx/OpenWindow",
        opts,
      )
    } catch (error) {
      window.toggleLoading(false)
      await window.message("warning", error.message)
      return
    }

    window.output.Data.Metadata = newdata.Data.Metadata

    newdata = Formatter.formdata(window, newdata)
    window.customData.FullTable = newdata.FullTable
  }

  window.toggleLoading(false)

  /* Set comboboxes */
  /* Set data on editable */
  window.customData.combobox.type.setInitialValues(
    window.customData.SelectText,
    window.customData.SelectValue,
  )

  window.customData.combobox.value.setInitialValues(
    window.customData.SelectionObjectText,
    window.customData.SelectionObjectValue,
  )

  if (!window.restoreWindowObject || !window.restoreWindowObject.quickEditAvoidRequestRows) {
    handleRows(window, newdata.Data.Rows)
  }

  await window.render()

  window.restoreWindowObject = {}
}

function handleRows(window, rows) {
  window.customData.rows = []

  rows.forEach(function createCustomRow(row, rowIndex) {
    let cells = {}
    let editable = {}
    let rowMeta =
      ((window.output.Data || {}).Metadata[rowIndex] || {})["*"] || {}

    for (let property in window.output.Data.Columns) {
      if (window.output.Data.Columns[property].Dropdown) {
        let column = window.customData.FullTable.Rows[rowIndex].filter(
          x => x.Column.Name == property,
        )[0]
        cells[property] = {Combobox: column.Combobox}
      }

      if (window.output.Data.Columns[property].AllowEditOnTable) {
        editable[property] = true
      }
    }

    window.customData.rows.push({
      used: formatRow(window, row),
      old: row,
      editable: editable,
      cells: cells,
      selected: false,
      groupedRow: rowMeta.GroupedRow === true,
    })
  })

  window.customData.useGroupedRows = window.customData.rows.some(
    row => row.groupedRow === true,
  )

  for (let i = 0; i < window.customData.rows.length; i++) {
    let item = window.customData.rows[i]
    let row = item.old

    // HC custom!
    if (
      row.ItemID === null ||
      (row.ItemID !== "10000" &&
        row.ItemID !== "10115" &&
        row.ItemID !== "99-004")
    ) {
      item.editable.L_Attenuation = false
      item.editable.R_Attenuation = false
    }
  }

  // Move customData.FullTable to output.FullTable (output contains original data)
  window.output.FullTable = window.customData.FullTable
}

/** @ignore */
export default new QuickEditHook()
